import React from 'react';
import classNames from 'classnames';
import { sizeOptions } from '../../../helpers/enums/themes/sizeOptions.js';
import styles from './Toggle.scss.js';
import { ToggleTheme } from './ThemeTypes.js';

const Toggle = _ref => {
  let {
    value = '0',
    shouldShowText = true,
    labelOff = 'Off',
    labelOn = 'On',
    size = sizeOptions.small,
    disabled = false,
    theme = ToggleTheme.CIRCLE,
    onChange = () => {}
  } = _ref;
  const onToggle = () => {
    if (!disabled) {
      onChange(value === '0' ? '1' : '0');
    }
  };
  return /*#__PURE__*/React.createElement("button", {
    role: "switch",
    "aria-checked": value === '1',
    tabIndex: 0,
    className: classNames(styles.wrapper, {
      [styles[`wrapper--theme-${theme}`]]: true,
      [styles[`wrapper--${size}--theme-${theme}`]]: true,
      [styles['wrapper--off']]: value === '0',
      [styles['wrapper--on']]: value === '1',
      [styles[`wrapper--on--theme-${theme}`]]: value === '1',
      [styles['wrapper--disabled']]: disabled
    }),
    onClick: onToggle
  }, theme === ToggleTheme.PILL ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.label, {
      [styles[`label-off--theme-${theme}`]]: true
    }),
    "aria-hidden": "true"
  }, shouldShowText && labelOff), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.label, {
      [styles[`label--theme-${theme}`]]: true
    }),
    "aria-hidden": "true"
  }, shouldShowText && labelOn), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.bar, {
      [styles[`bar--theme-${theme}`]]: true
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.circle, {
      [styles[`circle--theme-${theme}`]]: true
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.label, {
      [styles[`label--theme-${theme}`]]: true
    }),
    "aria-hidden": "true"
  }, shouldShowText && (value === '1' ? labelOn : labelOff))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.label,
    "aria-hidden": "true"
  }, shouldShowText && labelOff), /*#__PURE__*/React.createElement("div", {
    className: styles.bar
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label,
    "aria-hidden": "true"
  }, shouldShowText && labelOn), /*#__PURE__*/React.createElement("div", {
    className: styles.circle
  }))));
};
var Toggle$1 = Toggle;

export { Toggle$1 as default };
//# sourceMappingURL=Toggle.js.map
